import script from "./CourseOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseOverview.vue?vue&type=script&setup=true&lang=js"

import "./CourseOverview.vue?vue&type=style&index=0&id=cba4d9a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cba4d9a4"]])

export default __exports__